/**
 * Color adjustments
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';
import { getCa, setCa } from '../shared/color-adjustments.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        $('.ca-wrapper input').on('change', function () {
            const $this = $(this);
            setCa($this.val(), !!$this.prop('checked'));
        }).each(function () {
            const $this = $(this);
            $this.prop('checked', getCa($this.val()));
        });
    }
}, ['color-adjustments']);
